import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Abre Certy',
    body: 'La aplicación localiza los certificados instalados en el equipo y muestra su estado.',
  },
  {
    number: '02',
    title: 'Elige una identidad',
    body: 'Busca por titular, empresa o emisor y selecciona el certificado que necesitas.',
  },
  {
    number: '03',
    title: 'Trabaja sin mezclar sesiones',
    body: 'Abre el portal en una pestaña propia. Certy mantiene asociado el certificado elegido.',
  },
];

const HowItWorks: React.FC = () => (
  <section id="workflow" className="border-b border-[#c9d2cc] bg-[#07110d] py-14 text-white md:py-16" aria-labelledby="como-funciona">
    <div className="mx-auto max-w-[1240px] px-5 sm:px-8 lg:px-10">
      <div className="grid gap-6 border-b border-white/15 pb-8 lg:grid-cols-[0.72fr_1.28fr]">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#85f6aa]">Cómo funciona</p>
        <h2 id="como-funciona" className="max-w-[16ch] text-3xl font-semibold leading-[1] tracking-[-0.045em] md:text-5xl">
          Del certificado al trámite, en tres pasos.
        </h2>
      </div>
      <div className="grid md:grid-cols-3">
        {steps.map((step) => (
          <article key={step.number} className="border-b border-white/15 py-7 md:border-b-0 md:border-r md:px-7 md:first:pl-0 md:last:border-r-0 md:last:pr-0">
            <span className="text-xs font-semibold tracking-[0.18em] text-[#85f6aa]">{step.number}</span>
            <h3 className="mt-5 text-xl font-semibold">{step.title}</h3>
            <p className="mt-3 max-w-[34ch] text-sm leading-6 text-[#c9d7ce]">{step.body}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
